module.exports = __webpack_public_path__ + "img/2019103002.b627989a.jpg";